import React from 'react';
import ImageList from "@material-ui/core/ImageList";
import ImageListItem from "@material-ui/core/ImageListItem";
import LocationCard from '../locations/LocationCard';
import { makeStyles } from "@material-ui/core/styles";

const styles = makeStyles((theme) => ({
    organisationCards: {
        backgroundColor: theme.palette.background.paper,
        padding: "32px 0px",
    },
    organisationCardsHeader: {
        backgroundColor: theme.palette.primary.darkest,
        textAlign: "left",
        padding: "40px",
    },
}));

export const OrganisationTiles = ({ organisations }) => {
    const classes = styles();


    return (
            <div className={classes.organisationCards}>
                <ImageList rowHeight={500} cols={3} gap={6}>
                    {organisations.map(organisation =>
                        <ImageListItem key={organisation.name} cols={1}>
                            <LocationCard location={organisation} />
                        </ImageListItem>
                    )}
                </ImageList>
            </div>
    )
}

OrganisationTiles.NAME = "OrganisationTiles";
export default OrganisationTiles;


